import { FlexLockQuery, FlexLockCommandArgs } from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import t from '../../i18n/I18n';
import { forceReRender } from '../../util/AssetsUtil';

export default class LockQuery {
  updateProgress = _.noop;

  constructor(updateProgress) {
    this.updateProgress = updateProgress;
  }

  run(remotePaths, assets) {
    const query = new FlexLockQuery();
    let message = new FlexLockCommandArgs();
    message.setInfiles(remotePaths);
    message.setRemote(true);
    query.message = message;
    //this.updateProgress(0, t('PLEASE_WAIT'), 'RUNNING');
    query
      .run()
      .then(
        (resp) => {
          this.updateProgress(100, resp.getSuccessMessage(), 'DONE');
          if (!resp.isSuccess()) ErrorHandler.handleError(resp.getSuccessMessage());
          else {
            const lcTime = resp._lockTime;
            const usName = resp._username;
            assets.forEach((asset) => {
              asset.setIsLocked(true);
              asset.setLockTime(lcTime);
              asset.setLockOwner(usName);
            });
            forceReRender();
          }
        },
        (failedResp) => {
          const error = failedResp.errorDetails ? failedResp.errorDetails : t('DEFAULT_ERROR_MSG');
          ErrorHandler.handleError(error);
          this.updateProgress(100, error, null, false);
        }
      )
      .finally(() => {
        if (this.updateProgress) {
          this.updateProgress(100, '', null, false);
        }
      });
  }
}
